import { ValidPhoneAuthCodeTokenResponseDto } from "@/data/dto/valid-phone-auth-code-token-response-dto";
import { SelfSignupTokenEntity } from "@/domain/entity/self-signup-token-entity";
import { assertValidPhoneAuthCodeTokenResponseDto } from "@/utils/validation/generated/valid-phone-auth-code-token-response-dto.validator";

export class SelfSignupTokenMapper {
  static toEntity(dto: ValidPhoneAuthCodeTokenResponseDto): SelfSignupTokenEntity {
    assertValidPhoneAuthCodeTokenResponseDto(dto);
    return new SelfSignupTokenEntity(dto.token);
  }
}
